var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.332 27.76Q6 20.214 6 14.573C6 8.734 10.477 4 16 4s10 4.734 10 10.574q0 5.64-9.332 13.186a1.05 1.05 0 0 1-1.336 0M16 25.722c-2.726-2.26-4.716-4.324-6.034-6.187C8.55 17.535 8 15.896 8 14.573 8 9.734 11.685 6 16 6s8 3.732 8 8.574c0 1.322-.55 2.961-1.965 4.961-1.319 1.863-3.31 3.927-6.035 6.187",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.002 18c2.194.007 3.982-1.78 3.998-3.998A4.003 4.003 0 0 0 16.002 10c-2.197-.01-3.987 1.78-4.002 4.002.016 2.22 1.806 4.007 4.002 3.998M14 14c.015-1.13.923-2.005 1.993-2l.009-2v2c1.097 0 1.994.893 1.998 1.994-.012 1.134-.92 2.01-1.992 2.006h-.015c-1.069.005-1.977-.868-1.993-2",
    clipRule: "evenodd"
  })));
};
export default SvgPin;